import type { AnalyticsOverview } from '../../services/analytics';
import { DASH, formatInt, formatPct } from './format';
import type { MetricInfoKey } from './metricInfo';

export type SetupCardId = Extract<MetricInfoKey, 'setupD30' | 'pagouNuncaAcessou'>;

export interface SetupCardView {
    id: SetupCardId;
    title: string;
    value: string;
    caption: string;
    highlight?: boolean;
}

/** "0% de 21 pagantes com 30 dias de observação". Sem grupo, nao ha percentual. */
export function setupCaption(pct: number | null, base: number): string {
    if (base <= 0 || pct === null) return 'Sem pagantes com 30 dias de observação';
    return `${formatPct(pct)} de ${formatInt(base)} ${base === 1 ? 'pagante' : 'pagantes'} com 30 dias de observação`;
}

/** Cards da secao Setup proposto, na ordem e com os textos do prototipo. */
export function buildSetupCards(o: Pick<AnalyticsOverview, 'setupD30' | 'pagouNuncaAcessou'>): SetupCardView[] {
    return [
        {
            id: 'setupD30',
            title: 'Setup proposto · D30',
            value: o.setupD30.base > 0 ? formatInt(o.setupD30.count) : DASH,
            caption: setupCaption(o.setupD30.pct, o.setupD30.base),
            highlight: true,
        },
        {
            id: 'pagouNuncaAcessou',
            title: 'Pagou e nunca acessou',
            value: formatInt(o.pagouNuncaAcessou.count),
            caption: 'Pagamento registrado; nenhum acesso ou ação de produto até a data final',
        },
    ];
}
